import type { Data } from '@strapi/types';
import { useQuery } from '@tanstack/react-query';
import { getProjects } from '../api/project.api';
import { useAuth } from '@power-core/toolkit';

export const useProjectListInit = (title?: Pick<Data.Entity<'api::project.project'>, 'title'>['title'], sort?: string) => {
	const { auth } = useAuth();

	const {
		data: projects,
		error,
		isPending,
	} = useQuery({
		queryKey: ['GET_PROJECT_LIST', title, sort],
		queryFn: () => getProjects(title, sort),
		refetchOnWindowFocus: true,
		refetchOnReconnect: false,
		enabled: auth.status === 'authenticated',
	});

	return {
		projects,
		error,
		isPending,
	};
};
